import { Component, Input, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { IconService } from '../../icons/icon.service';
import DOMPurify from 'dompurify';
import { ICONS } from './icon';

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-icons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icons.component.html',
  styleUrl: './icons.component.css',
})
export class IconsComponent implements OnInit {
  safeHtmlContent: string;
  images: { [key: string]: SafeHtml } = {};
  @Input() name: keyof typeof ICONS;
  sanitizedIcon: any;

  constructor(private IconService: IconService) {}

  ngOnInit() {
    const rawIcon = ICONS[this.name] || '';
    this.sanitizedIcon = this.IconService.sanitize(rawIcon);

    // console.log("  this.images", this.images)
  }
}
